function initFaqAccordions() {
  document.querySelectorAll('.faq-accordion__item').forEach((item) => {
    if (item.dataset.faqInit) return;
    item.dataset.faqInit = 'true';

    const summary = item.querySelector('.faq-accordion__question');
    const answer = item.querySelector('.faq-accordion__answer');
    if (!summary || !answer) return;

    summary.addEventListener('click', (e) => {
      e.preventDefault();

      const isOpen = item.hasAttribute('open');

      if (isOpen) {
        // Closing: measure current height, then animate to 0
        const startHeight = answer.scrollHeight;
        answer.style.height = startHeight + 'px';
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            answer.style.height = '0px';
          });
        });
        answer.addEventListener('transitionend', function onEnd() {
          answer.removeEventListener('transitionend', onEnd);
          item.removeAttribute('open');
        }, { once: true });
      } else {
        // Opening: set open so content is measurable, animate from 0 to scrollHeight
        item.setAttribute('open', '');
        const targetHeight = answer.scrollHeight;
        answer.style.height = '0px';
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            answer.style.height = targetHeight + 'px';
          });
        });
        answer.addEventListener('transitionend', function onEnd() {
          answer.removeEventListener('transitionend', onEnd);
          answer.style.height = 'auto';
        }, { once: true });
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFaqAccordions);
} else {
  initFaqAccordions();
}

document.addEventListener('shopify:section:load', () => {
  initFaqAccordions();
});